import { render, staticRenderFns } from "./live-stream.vue?vue&type=template&id=654c2cf3&scoped=true"
import script from "./live-stream.vue?vue&type=script&lang=js"
export * from "./live-stream.vue?vue&type=script&lang=js"
import style0 from "./live-stream.vue?vue&type=style&index=0&id=654c2cf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c2cf3",
  null
  
)

export default component.exports